import { deepArchive } from "@/mocks/blackmole";
import { chipTone, solidTone } from "./tone";

export default function DeepArchive() {
  return (
    <section id="deep" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-700">
              <span className="inline-block h-px w-6 bg-primary-500"></span>
              深挖抢先版 · 从苗头到内幕
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              连载式深挖档案
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              标题先行、进度可见，把一条突发爆料拆成几轮来更，抢先版比快讯多一层来龙去脉。
            </p>
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {deepArchive.map((d) => (
            <article
              key={d.no}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100/70 p-6 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`rounded-md px-2 py-1 text-xs font-bold tracking-wider ${solidTone[d.tone]}`}
                >
                  {d.no}
                </span>
                <span
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${chipTone[d.tone]}`}
                >
                  <span className={`h-1.5 w-1.5 rounded-full ${d.status === "深挖中" ? "bg-current" : "bg-foreground-400"}`}></span>
                  {d.status}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                {d.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{d.teaser}</p>

              <div className="mt-5">
                <div className="mb-1.5 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-refresh-line text-xs"></i>
                    {d.rounds}
                  </span>
                  <span className="font-semibold text-foreground-700">{d.progress}%</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`h-full rounded-full ${d.tone === "primary" ? "bg-primary-500" : d.tone === "accent" ? "bg-accent-500" : d.tone === "secondary" ? "bg-secondary-500" : "bg-foreground-700"}`}
                    style={{ width: `${d.progress}%` }}
                  ></div>
                </div>
              </div>

              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-500">
                  <i className="ri-lock-line mr-1 align-middle text-xs"></i>
                  抢先版内容仅订阅可见
                </span>
                <button
                  type="button"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-600"
                >
                  查看抢先版
                  <i className="ri-eye-line text-sm"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}